export const UNALLOCATED_PROJECTS = 'Нераспределенные проекты';
export const UNDEFINED_VENUE = 'Неопределенная площадка';
export const UNDEFINED_STREAM = 'Неопределенный поток';
export const DEFAULT_IMAGE_URL = "https://img.freepik.com/free-psd/3d-illustration-bald-person-with-glasses_23-2149436184.jpg?w=2000&t=st=1706116706~exp=1706117306~hmac=5912213c4314755aaeae4c43629211b65948e2b570802c4a0c936e33538e6d58";

export const REFLECTION_FORMATS = "image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/zip,application/x-rar-compressed,application/x-7z-compressed";

// для итоговых заметок — строго docx
export const RESULTS_APPLICATION_FORMATS = ".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
